import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { NftPdpExhibitionNoteRichText_note$key } from './__generated__/NftPdpExhibitionNoteRichText_note.graphql';

import styles from './NftPdpExhibitionNoteRichText.scss';

type Props = {
    note: NftPdpExhibitionNoteRichText_note$key;
};

export const NftPdpExhibitionNoteRichText: FC<Props> = ({ note: noteRef }) => {
    const note = useFragment(
        graphql`
            fragment NftPdpExhibitionNoteRichText_note on NftExhibitionNoteRichTextContent {
                content
            }
        `,
        noteRef
    );
    const content = note?.content || '';
    return <div className={styles.bodyText} dangerouslySetInnerHTML={{ __html: content }} />;
};
